export default __webpack_public_path__ + "static/media/miguel-lopes-40.603838c3.jpg";